var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"bg",attrs:{"inset":""}},[_c('v-card-text',{staticClass:"py-1 white--text text-center"},[_vm._v(" "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v("Booking CRC Kuching")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }